import { Api } from "../config/request";

export default {
  getGeoBoundaries(payload) {
    return Api.post("/locations/boundaries", payload);
  },
};
